import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const EditButton = ({ action, loading, selectedFiles }) => {
  const { t } = useTranslation();

  return (
    <>
      <Button
        startIcon={<EditIcon />}
        onClick={action}
        size="small"
        variant="text"
        color="inherit"
        disabled={loading || selectedFiles.length !== 1 || selectedFiles[0].dir}
      >
        {t('buttons.edit', { ns: 'fileBrowser' })}
      </Button>
    </>
  );
};

EditButton.propTypes = {
  action: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  selectedFiles: PropTypes.array.isRequired,
};

export default EditButton;
